export const formatNfeChave = (value) => {
  if (!value) return "";

  // Remove tudo que não for número
  const numbers = value.replace(/\D/g, "");

  // Limita a 44 dígitos
  const limited = numbers.substring(0, 44);

  // Adiciona espaço a cada 4 dígitos
  return limited.replace(/(\d{4})(?=\d)/g, "$1 ");
};